import TutorialButton from '@components/common/TutorialButton';
import { BookmarkBorderOutlined, FilterList, List, LocalOfferOutlined, PentagonOutlined, Settings } from '@mui/icons-material';
import { Box, CircularProgress } from '@mui/material';
import { IStoreState } from '@store/index';
import { setActiveSidePanel, setMobileEventListOpen } from '@store/views/overviewView/actions';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConnectivityStatus from './ConnectivityStatus';
import ToolbarIcon from './ToolbarIcon';
import { useMobileQuery } from '@hooks/useMobileQuery';
import { useSmallScreenQuery } from '@hooks/useSmallScreenQuery';

type ToolbarProps = {
  loadingTab: boolean;
}

const Toolbar: React.FC<ToolbarProps> = (props) => {
  const { loadingTab } = props;

  const isMobile = useMobileQuery();
  const isSmallScreen = useSmallScreenQuery();
  const mobileEventListOpen = useSelector((store: IStoreState) => store.overviewView.mobileEventListOpen);

  const dispatch = useDispatch();

  const eventInboxSidePanel = useSelector((store: IStoreState) => store.overviewView.eventInboxSidePanel);
  const tutorialsEnabled = useSelector((store: IStoreState) => store.tutorials.tutorialsEnabled);

  function handleFiltersClick(): void {
    if (eventInboxSidePanel !== "filter_panel") dispatch(setActiveSidePanel("filter_panel"))
    else dispatch(setActiveSidePanel("none"));
  }

  function handleOptionsClick(): void {
    if (eventInboxSidePanel !== "options_panel") dispatch(setActiveSidePanel("options_panel"))
    else dispatch(setActiveSidePanel("none"));
  }

  function handleZonesClick(): void {
    if (eventInboxSidePanel !== "zones") dispatch(setActiveSidePanel("zones"))
    else dispatch(setActiveSidePanel("none"))
  }

  function handleTagClick(): void {
    if (eventInboxSidePanel !== "tag_panel") dispatch(setActiveSidePanel("tag_panel"))
    else dispatch(setActiveSidePanel("none"))
  }

  function handleExportsClick(): void {
    if (eventInboxSidePanel !== "exports") dispatch(setActiveSidePanel("exports"))
    else dispatch(setActiveSidePanel("none"))
  }

  function handleEventListClick(): void {
    dispatch(setMobileEventListOpen(!mobileEventListOpen))
  }

  return (
    <Box
      height="100%"
      borderLeft="1px solid rgba(0, 0, 0, 0.12)"
      padding="0.2rem"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      {tutorialsEnabled &&
        <TutorialButton
          tutorialType="overview_event_inbox"
          IconButtonProps={{ style: { padding: 8 } }}
        />
      }
      {(isMobile || isSmallScreen) &&
        <ToolbarIcon
          tooltipTitle='Event list'
          icon={<List />}
          onClick={handleEventListClick}
          dataCy="overview-event-list-icon-button"
        />
      }
      <ToolbarIcon
        tooltipTitle='Filters'
        icon={<FilterList />}
        onClick={handleFiltersClick}
        color={eventInboxSidePanel === "filter_panel" ? 'primary' : undefined}
        dataCy="overview-toolbar-filter-icon-button"
      />
      <ToolbarIcon
        tooltipTitle='Tag events'
        icon={<LocalOfferOutlined />}
        onClick={handleTagClick}
        color={eventInboxSidePanel === "tag_panel" ? 'primary' : undefined}
        dataCy="overview-toolbar-tag-panel-icon-button"
      />
      {!isMobile && !isSmallScreen &&
        <ToolbarIcon
          tooltipTitle='Zones'
          icon={<PentagonOutlined />}
          onClick={handleZonesClick}
          color={eventInboxSidePanel === "zones" ? 'primary' : undefined}
          dataCy="overview-toolbar-zones-icon-button"
        />
      }
      <ToolbarIcon
        tooltipTitle='Exports'
        icon={<BookmarkBorderOutlined />}
        onClick={handleExportsClick}
        color={eventInboxSidePanel === "exports" ? 'primary' : undefined}
        dataCy="overview-toolbar-exports-icon-button"
      />
      <ToolbarIcon
        tooltipTitle='Options'
        icon={<Settings />}
        onClick={handleOptionsClick}
        color={eventInboxSidePanel === "options_panel" ? 'primary' : undefined}
        dataCy="overview-toolbar-options-icon-button"
      />
      <ConnectivityStatus />
      {loadingTab === true &&
        <ToolbarIcon
          tooltipTitle='Events are being scanned from the database...'
          icon={<CircularProgress size="1.5rem" data-cy="toolbar-circular-progress" />}
          disableRipple
        />
      }
    </Box>
  )
}

export default Toolbar;
